import {
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    sendEmailVerification,
    signInWithPhoneNumber,
    RecaptchaVerifier,
    updateProfile,
    GoogleAuthProvider,
    FacebookAuthProvider,
    TwitterAuthProvider,
    signOut
} from "firebase/auth";

import app from "../firebase/firebase";

import {
    firebaseLoginAPICall,
    saveLoggedInUser,
    storeToken,
    getUserAppById
} from "../pages/userapp/ServiceUserApp";


const auth = getAuth(app);


//=====================================================
// Providers
//=====================================================

const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
const twitterProvider = new TwitterAuthProvider();


//=====================================================
// Classe principale
//=====================================================

class FirebaseAuthService {


    //=================================================
    //  {t("connexion.login")} Google
    //=================================================

    async loginWithGoogle() {
        try {
            const result = await signInWithPopup(
                auth,
                googleProvider
            );

            return await this.authenticateWithBackend(result);

        } catch (error) {

            console.error(error);
            throw error;

        }

    }

c
    //=================================================
    //  {t("connexion.login")} Facebook
    //=================================================

    async loginWithFacebook() {
        try {
            const result = await signInWithPopup(
                auth,
                facebookProvider
            );

            return await this.authenticateWithBackend(result);
        } catch (error) {

            console.error(error);
            throw error;

        }

    }


    //=================================================
    //  {t("connexion.login")} Twitter
    //=================================================

    async loginWithTwitter() {


        try {

            const result = await signInWithPopup(
                auth,
                twitterProvider
            );

            return await this.authenticateWithBackend(result);

        } catch (error) {

            console.error(error);
            throw error;

        }

    }

    //=================================================
    //  {t("connexion.login")} Email / Mot de passe
    //=================================================

    async loginWithEmail(email, password) {
        const result =
            await signInWithEmailAndPassword(
                auth,
                email,
                password
            );


        await result.user.reload();


        if (!result.user.emailVerified) {

            await signOut(auth);

            throw {
                code: "auth/email-not-verified"
            };

        }

        return await this.authenticateWithBackend(result);

    }


    //=================================================
    // Inscription
    //=================================================

    async registerWithEmail(user) {

        try {

            const result =
                await createUserWithEmailAndPassword(
                    auth,
                    user.email,
                    user.password
                );
            await updateProfile(result.user, {
                displayName: user.fullName
            });


            await sendEmailVerification(result.user);


            return await this.authenticateWithBackend(
                result,
                {
                    email: user.email,
                    phoneNumber: user.phoneNumber,
                    falahOrProf: user.falahOrProf
                }
            );

        } catch (error) {

            console.error(error);
            throw error;

        }

    }


    //=================================================
    // Mot de passe oublié
    //=================================================

    async forgotPassword(email) {

        try {

            await sendPasswordResetEmail(
                auth,
                email
            );

            return true;

        } catch (error) {

            console.error(error);
            throw error;

        }

    }


    //=================================================
    // Vérifie si l'email est validé
    //=================================================

    async checkEmailVerification() {

        if (!auth.currentUser) {
            return false;
        }

        await auth.currentUser.reload();

        return auth.currentUser.emailVerified;

    }


    async resendVerificationEmail() {

        if (!auth.currentUser) {

            throw new Error(
                "Aucun utilisateur connecté."
            );

        }

        await sendEmailVerification(
            auth.currentUser
        );

    }


    //=================================================
    // Envoi OTP
    //=================================================

    async sendPhoneOTP(phoneNumber) {

        try {

            if (!window.recaptchaVerifier) {

                window.recaptchaVerifier =
                    new RecaptchaVerifier(
                        auth,
                        "recaptcha-container",
                        {
                            size: "normal",
                            callback: () => {
                                //console.log( "reCAPTCHA validé." );
                            }
                        }
                    );

                await window.recaptchaVerifier.render();

            }


            const appVerifier =
                window.recaptchaVerifier;


            const confirmationResult =
                await signInWithPhoneNumber(
                    auth,
                    phoneNumber,
                    appVerifier
                );


            window.confirmationResult =
                confirmationResult;


            return confirmationResult;

        } catch (error) {

            console.error(error);
            throw error;

        }

    }


    //=================================================
    // Vérification OTP
    //=================================================

    async verifyPhoneOTP(code) {

        try {

            if (!window.confirmationResult) {

                throw {

                    code:
                        "auth/no-verification-id"

                };

            }


            const result =
                await window.confirmationResult.confirm(
                    code
                );


            return await this.authenticateWithBackend(
                result
            );

        } catch (error) {

            console.error(error);
            throw error;

        }

    }


    //=================================================
    // Communication Spring Boot
    //=================================================
//=================================================
// Communication Spring Boot
//=================================================

async authenticateWithBackend(result) {

    try {

        //--------------------------------------------------
        // Utilisateur Firebase
        //--------------------------------------------------

        const firebaseUser = result.user;

        console.log("Firebase User :", firebaseUser);


        //--------------------------------------------------
        // Token Firebase
        //--------------------------------------------------

        const idToken = await firebaseUser.getIdToken();

        console.log("Firebase Token OK");


        //--------------------------------------------------
        // Authentification Spring Boot
        //--------------------------------------------------

        console.log("Appel firebaseLoginAPICall()");

        const response = await firebaseLoginAPICall({
            idToken: idToken
        });

        console.log("Réponse Login :", response);


        //--------------------------------------------------
        // Données retournées
        //--------------------------------------------------

        const login = response.data;

        console.log("login =", login);

        //--------------------------------------------------
        // Sauvegarde JWT
        //--------------------------------------------------

        console.log("JWT =", login.token);

        storeToken(login.token);


        //--------------------------------------------------
        // Récupération utilisateur
        //--------------------------------------------------

        console.log(
            "Appel getUserAppById() avec l'id = ",
            login.id
        );

        const userResponse =
            await getUserAppById(login.id);

        console.log(
            "userResponse = ",
            userResponse
        );


        //--------------------------------------------------
        // Utilisateur complet
        //--------------------------------------------------

        const user = userResponse.data;

        console.log("user =", user);


        //--------------------------------------------------
        // Sauvegarde LocalStorage
        //--------------------------------------------------

        saveLoggedInUser(user);


        //--------------------------------------------------
        // Retour
        //--------------------------------------------------

        return user;

    }
    catch (error) {

        console.log("------------------------------------");
        console.log("ERREUR AUTHENTIFICATION");
        console.log("------------------------------------");

        if (error.response) {

            console.log("STATUS :", error.response.status);
            console.log("DATA :", error.response.data);
            console.log("HEADERS :", error.response.headers);

        }
        else {

            console.log("MESSAGE :", error.message);

        }

        console.error(error);

        throw error;
    }

}

    //=================================================
    // Déconnexion
    //=================================================

    async logout() {

        await signOut(auth);

        localStorage.removeItem("token");
        localStorage.removeItem("user");

    }


    //=================================================
    // Utilisateur courant
    //=================================================

    getCurrentUser() {

        return auth.currentUser;

    }


    //=================================================
    // Token Firebase
    //=================================================

    async getFirebaseToken() {

        if (!auth.currentUser) {

            return null;

        }

        return await auth.currentUser.getIdToken();

    }


    //=================================================
    // Rafraîchissement Token Firebase
    //=================================================

    async refreshFirebaseToken() {

        if (!auth.currentUser) {

            return null;

        }

        return await auth.currentUser.getIdToken(true);

    }

}

export default new FirebaseAuthService();